/**
 * Created by face on 2017/11/8 9:25.
 */
import * as React from 'react';
import Loading from '../../components/loading/Loading';
import Utils from '@chehejia/club-lib/lib/utils/Utils';
// import {reset} from '../../model'
// import {Store} from '../../model'
import { observer, inject } from 'mobx-react';
@inject('store')
export default class Preload extends React.Component<any, any> {
    public constructor(props) {
        super(props);
    }

    public componentWillMount() {
        document.title = '车和家';
        let path = Utils.getQuertString('redirect');
        if (path) {
            if (path.indexOf('mobile') > -1) {
                const posstart = path.indexOf('/', path.indexOf('mobile'));
                path = path.substr(posstart);
                this.props.history.push(path, {from: 'hayner'});
            } else {
                window.location.href = path;
            }
        }
        // this.props.store.reset()
    }

    public componentDidMount() {
        // if (window['chj-page-view-start']) {
        // }
    }
    public render() {
        return (
            <Loading />
        );
    }
}
